angular
    .module('festzelt-os.components')
    .config([
        '$httpProvider',
        interceptor
    ]);

function interceptor($httpProvider) {
    $httpProvider.interceptors.push([
        '$injector',
        '$location',
        '$q',
        function ($injector, $location, $q) {
            return {
                'responseError': function (rejection) {
                    if (rejection.status === 401) {
                        const $auth = $injector.get('$auth'),
                            $state = $injector.get('$state'),
                            token = $auth.getToken();
                        if (token) {
                            $auth.removeToken();
                            $state.back() || $state.go('app.dashboard');
                        }
                    }
                    return $q.reject(rejection);
                }
            };
        }
    ]);
}



// WEBPACK FOOTER //
// ./src/app/pages/auth/auth-intercepts.js